export default "__VITE_ASSET__BC12YmRX__"